import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "component/common/breadcrumb";
import strings from "translate/language";
import { useDispatch, useSelector } from "react-redux";
import usePermission from "utils/usePermission";
import { getRegistrationList } from "../../reduxStore/action/registrationActions";
import { handleListResponse, seo } from "utils/utils";
import usePage from "utils/usePage";
import moment from "moment";
import TableDataNotFound from "component/TableDataNotFound";
import Pagination from "component/common/Pagination";
import {
  getReportPropertyList,
} from "reduxStore/action/reportActions";
import Select from "react-select";

const Registration = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = usePage();
  const [formVaild, setFormVaild] = useState({});
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [propertyList, setPropertyList] = useState([]);
  const [registrationList, setRegistrationList] = useState([]);
  const ReportListSelector = useSelector((state) => state.report);
  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    limit: "",
    offset: "",
    property_name: "",
    customer_name: ""
  });
  const registrationListSelector = useSelector((state) => state?.registration);

  const { view } = usePermission({ view: "view_registration" });

  const navigatpage = async (navname) => {
    navigate(navname);
  };

  useEffect(() => {
    const { reportPropertyList } = ReportListSelector;
    if (reportPropertyList) {
      if (reportPropertyList?.status === 200) {
        setPropertyList(handleListResponse(reportPropertyList.data));
      } else {
        setPropertyList([]);
      }
    }
  }, [ReportListSelector]);

  useEffect(() => {
    if (registrationListSelector?.response?.status === 200) {
      if (registrationListSelector?.response?.data?.length > 0) {
        setRegistrationList(
          handleListResponse(registrationListSelector?.response?.data)
        );
      }
    } else {
      setRegistrationList([]);
    }
  }, [registrationListSelector]);

  useEffect(() => {
    dispatch(getRegistrationList({ limit: 10, offset: page }));
  }, [dispatch]);

  const filterDetail = () => {
    if (!handleValid()) {
      dispatch(
        getRegistrationList({
          limit: 10,
          offset: 0,
          start_date: form.start_date,
          end_date: form.end_date,
          property_name: form?.site?.property_title,
          customer_name: form.customer_name,
        })
      );
      setPage(0);
    }
  };

  const filterReset = () => {
    setForm({
      start_date: "",
      end_date: "",
      property_name: "",
      customer_name: "",
      site: "",
    });
    setFormVaild({
      ...formVaild,
      end_date: ""
    })
    dispatch(getRegistrationList({ limit: 10, offset: 0 }));
    setPage(0);
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (form.start_date !== "") {
      if (form.end_date === "") {
        formError = true;
        err["end_date"] = strings.endDateErr;
      }
    }
    setFormVaild(err);
    return formError;
  };

  const handlePageClick = (newOffset) => {
    setPage(newOffset);
    dispatch(
      getRegistrationList({
        limit: 10,
        offset: newOffset,
        start_date: form.start_date,
        end_date: form.end_date,
        property_name: form?.site?.property_title,
        customer_name: form.customer_name,
      })
    );
  };
  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    if (e.target.name === "end_date") {
      setFormVaild({
        ...formVaild,
        end_date: ""
      })
    }
  };

  // Disable end_date
  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  useEffect(() => {
    seo({
      title: "Registration Listing",
      metaDescription: "Registration list",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.registration}
        titleactive={strings.registraionListing}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">{strings.startDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              data-target="#dt-date"
                              name="start_date"
                              value={form.start_date}
                              onChange={handleInputField}
                              min={form.start_date}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.endDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              name="end_date"
                              value={form.end_date}
                              onChange={handleInputField}
                              min={form.start_date}
                              // max={form.end_date}
                              disabled={endDateDisable}
                            />
                          </div>
                          {formVaild.end_date && (
                            <span style={{ color: "red" }}>
                              {formVaild.end_date}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.searchByCustomerName}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="text"
                              name="customer_name"
                              placeholder="Search Customer Name"
                              value={form.customer_name}
                              onChange={handleInputField}
                              min={form.start_date}
                              max={form.customer_name}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-4">
                          <span className="cardText">{strings.searchByPropertyName}</span>
                          <Select
                            isSearchable
                            isClearable
                            onInputChange={(e) => {
                              if (e.length > 1) {
                                dispatch(
                                  getReportPropertyList({
                                    search_site: e,
                                    isLoadMore: true,
                                  })
                                );
                              } else {
                                dispatch(
                                  getReportPropertyList({
                                    limit: 10,
                                    offset: 0,
                                    isLoadMore: true,
                                  })
                                );
                              }
                            }}
                            placeholder={strings.searchByPropertyName}
                            options={propertyList}
                            getOptionLabel={(option) =>
                              `${option.property_title}`
                            }
                            getOptionValue={(option) => option._id}
                            name="site"
                            value={form.site}
                            onChange={(e) => {
                              setForm({ ...form, site: e });
                            }}
                          />
                        </div>
                        <div className="col-md-8 pt-4">
                          <div className="form-group d-flex justify-content-end">
                            <button
                              className="btn btn-warning mr-4"
                              type="button"
                              onClick={filterDetail}
                            >
                              {strings.search}
                            </button>
                            <button
                              className="btn btn-dark"
                              type="button"
                              onClick={filterReset}
                            >
                              {strings.reset}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h5>{strings.registraionList}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead className="text-center">
                        <tr>
                          <th scope="col">{strings.propertyName}</th>
                          <th scope="col">{strings.bookingDate}</th>
                          <th scope="col">{strings.customerName}</th>
                          <th scope="col">{strings.bookingNumber}</th>
                          <th scope="col">{strings.configuration}</th>
                          <th scope="col">{strings.status}</th>
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {registrationList?.length > 0 ? (
                          registrationList.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item.property_title}</td>
                                <td>
                                  {moment(item.registration_date).format(
                                    "DD-MM-yyyy hh:mm a"
                                  )}
                                </td>
                                <td>{item.customer_first_name}</td>
                                <td>{item.booking_no}</td>
                                <td>{item.configuration_title ? item.configuration_title : "-"}</td>
                                <td style={{ color: "green", fontWeight: "bold" }}>{"Registered"}</td>
                                {view && (
                                  <td className="p-2">
                                    <i
                                      className="fa fa-eye theme-fa-icon mr-3"
                                      aria-hidden="true"
                                      title="View Registration"
                                      onClick={() => {
                                        navigatpage(
                                          `/view_registration/${item._id}`
                                        );
                                      }}
                                    ></i>
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <tr />
                        )}
                      </tbody>
                    </table>
                    <TableDataNotFound data={registrationList} />
                  </div>
                  <Pagination
                    totalCount={registrationListSelector?.response?.total_data}
                    listData={registrationList}
                    onPageChange={handlePageClick}
                    itemOffset={page}
                    setItemOffset={setPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Registration;
